import { useContext } from 'react';
import { ShowAndTellContext, type ShowAndTellApi } from './showAndTellStore';

export function useShowAndTell(): ShowAndTellApi {
  const api = useContext(ShowAndTellContext);
  if (!api) throw new Error('useShowAndTell must be used inside ShowAndTellProvider');
  return api;
}

/** For components that render outside the provider in tests or storybook-like contexts. */
export function useOptionalShowAndTell(): ShowAndTellApi | null {
  return useContext(ShowAndTellContext);
}
